import { useState, useEffect } from "react";
import React from "react";
export default function Paginationpage(props: any) {
  const [value, setValue] = useState(props.pagination.currentPage + 1);
  const [placeholder, setPlaceholder] = useState(
    props.pagination.currentPage + 1
  );

  useEffect(() => {
    setValue(props.pagination.currentPage + 1);
    setPlaceholder(props.pagination.currentPage + 1);
  }, [props.pagination.currentPage]);

  const updatePage = (e: any) => {
    e.preventDefault(e);
    const val = e.target.value.replace(/\D/g, "");
    setValue(val);
  };

  const callPagination = (e: any) => {
    let page = value;
    if (props.url != undefined) {
      const base = props.baseUrl;
      const pageURL = base + props.url.slice(1);
      const input: HTMLElement = document.getElementById(
        "pagination_input"
      ) as HTMLElement;
      if (
        e.key === "Enter" &&
        (page === null || page == undefined || page == "")
      ) {
        setValue(placeholder);
        input.blur();
      }
      if (e.key === "Enter" && page && page != 0 && page != null) {
        if (page > props.totalPage) {
          if (props.module == "schedule") {
            return;
          } else {
            page = "1" || 1;
            setValue(page);
          }
        }
        const url = pageURL;
        let searchPage;
        const href = new URL(url);
        console.log("href", href, href.href, url, page);
        if (props.module == "schedule") {
          searchPage = page - 1;
          href.searchParams.set("offset", `${searchPage}`);
        } else if (props.module == "test") {
          searchPage = (page - 1) * props.limit;
          href.searchParams.set("offset", `${searchPage}`);
        } else if (props.module == "myBatch") {
          searchPage = (page - 1) * props.limit;
          href.searchParams.set("offset", `${searchPage}`);
        } else {
          href.searchParams.set("page", `${page}`);
          props.fetchData(href.href);
        }
        console.log("href", href, href.href, url, page);
        props.fetchData(href.href, page);
        input.blur();
      }
    }
  };
  return (
    <>
      {props.pagination ? (
        <input
          id="pagination_input"
          value={isNaN(value) ? 0 : value}
          placeholder={placeholder}
          min="0"
          onChange={(e) => updatePage(e)}
          onKeyUp={(e) => callPagination(e)}
        />
      ) : null}
    </>
  );
}
